import { applyMiddleware, createStore } from 'redux';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { connectRouter } from 'connected-react-router';

import AccountReducer from 'redux/Account/AccountReducer';
import MessageReducer from 'redux/Message/MessageReducer';

const history = createBrowserHistory();
const routeMiddleware = routerMiddleware(history);
const bindMiddleware = middleware => {
  const { composeWithDevTools } = require('redux-devtools-extension');
  return composeWithDevTools(applyMiddleware(...middleware));
};

function configureStore(initialState = {}) {
  const store = createStore(
    combineReducers({
      AccountReducer,
      MessageReducer,
      router: connectRouter(history),
    }),
    initialState,
    bindMiddleware([routeMiddleware, thunk]),
  );
  return store;
}
export default configureStore;
export { history };
